import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import getProfessionAction from "./../../actions/ProfessionActions/getProfessionAction";
import getProfessionTitleSelector from "../../selectors/ProfessionSelectors/getProfessionTitleSelector";
import resetProfessionAction from "../../actions/ProfessionActions/resetProfessionAction";
import { useAppTitle } from "../MainHooks/useAppTitle";
import { useParams } from "react-router";

export default function useProfession() {
    const title = useSelector((state: Store) => getProfessionTitleSelector(state));
    const { setAppTitle } = useAppTitle();
    const { id } = useParams<{ id?: string }>();
    const dispatch = useDispatch();
    const getProfession = useCallback((id) => dispatch(getProfessionAction(id)), [dispatch]);
    const resetProfession = useCallback(() => dispatch(resetProfessionAction()), [dispatch]);
    useEffect(() => {
        getProfession(id);
        return () => {
            resetProfession();
        };
    }, [id, getProfession, resetProfession]);
    useEffect(() => {
        setAppTitle(title);
        return () => {
            setAppTitle("");
        };
    }, [title, setAppTitle]);
}
